import { api } from "./base-config";
import moment from "moment";
import { Insurability, InsurabilityType } from "model/insurability.model";

/** ---- API CALLS ---- */
export const find = async (
  userId: number,
  patientId: number
): Promise<InsurabilityType> => {
  return api
    .get(
      `/resources/secured/rs/caregivers/${userId}/patients/${patientId}/healthInsurances/date`,
      { params: { startDate: moment().format("DD/MM/YYYY") } }
    )
    .then(response => {
      const data = response.data;
      if (data && data.length > 0) {
        return mapToInsurabilityModel(data[0]);
      } else {
        return new Insurability();
      }
    });
};

export const isChronicPatient = async (
  userId: number,
  patientId: number
): Promise<boolean> => {
  return api
    .get(
      `/resources/secured/rs/caregivers/${userId}/patients/${patientId}/insuranceCurrentData/find`
    )
    .then(response => response.data)
    .then((dto: InsuranceCurrentDataDTO) => {
      return (dto.chronicYears || false) && dto.chronicYears.length > 0;
    });
};

/** ---- API MAPPING ---- */
const mapToInsurabilityModel = (
  insurabilityDTO: InsurabilityDTO
): InsurabilityType => {
  return {
    ct1: insurabilityDTO.ct1,
    ct2: insurabilityDTO.ct2
  };
};

/** ---- API DTO ---- */
interface InsurabilityDTO {
  readonly ct1: string;
  readonly ct2: string;
}

interface InsuranceCurrentDataDTO {
  readonly thirdPayer: boolean;
  readonly thirdPayerOverride?: boolean;
  readonly specialCategory: boolean;
  readonly medicalHouseNurse: boolean;
  readonly medicalHouseMedical: boolean;
  readonly medicalHousePhysio: boolean;
  readonly medicalHouseStartDate: Date;
  readonly medicalHouseEndDate: Date;
  readonly hospitalNihii: string;
  readonly hospitalName: string;
  readonly hospitalAdmissionDate: Date;
  readonly hospitalAdmissionService: string;
  readonly maxInvoiceYears: Array<string>;
  readonly wmhAttestation?: boolean;
  readonly chronicYears: Array<string>;
}
